import modulesMap from 'core/modulesMap';
import MainPage from 'navigation/pages/MainPage';
class PasswordReset extends MainPage {
    static pageName = 'PasswordReset';
    getModulesMap() {
        return {
            ...modulesMap,
            ...super.getModulesMap()
        };
    }
    initialized() {
        super.initialized();
    }
}
export default PasswordReset;
